/**
 * Centralized Google Maps configuration for the admin/ops web app.
 *
 * The browser-restricted key is read from REACT_APP_GOOGLE_MAPS_API_KEY
 * (Create-React-App requires the REACT_APP_ prefix to expose env vars to
 * the bundle). The key value is referenced by `<MapsProvider>` and any
 * direct callers of `useJsApiLoader`.
 */

export const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY ?? '';

/**
 * Single shared script-loader id. The Google Maps script can only be
 * loaded once per page; using the same id everywhere lets `@react-google-maps/api`
 * deduplicate requests across components.
 */
export const GOOGLE_MAPS_SCRIPT_ID = 'vinpulse-google-maps-script';

/**
 * Libraries we need across the app. `places` is required for the address
 * autocomplete in the ecommerce checkout (also imported by the web app
 * for any future address-search features). Keep this list stable — every
 * change forces the Maps script to re-load.
 */
export const GOOGLE_MAPS_LIBRARIES: ('places' | 'geometry' | 'drawing' | 'visualization')[] = [
  'places',
  'geometry',
];

/** Default map center used when no marker data is available (Louisville, KY HQ). */
export const DEFAULT_MAP_CENTER = { lat: 38.2527, lng: -85.7585 };

export function isMapsConfigured(): boolean {
  return GOOGLE_MAPS_API_KEY.length > 0;
}
